export function allocUnsafe (size: number): Uint8Array {
  return new Uint8Array(size)
}
